<div class="showlist-container">
  <!-- 標題列與新增按鈕 -->
  <div class="header-section">
    <div class="title-section">
      <h3>{{formName}}</h3>
      <!-- 欄位設定按鈕 -->
      <button class="column-settings-btn"
              (click)="openColumnSettings()"
              [title]="'form.list.column_settings' | translate">
        <i class="fas fa-columns"></i>
      </button>
    </div>
    <button class="btn btn-primary add-record-btn" (click)="createNewRecord()" title="{{ 'form.list.add_record' | translate }}">
      <i class="fas fa-plus"></i> {{ 'common.add' | translate }}
    </button>
  </div>

  <!-- 表格視圖 - 原始數據 -->
  <div class="table-wrapper">
    <table class="table">
      <thead>
        <tr>
            <th *ngIf="hasEditPermission() || hasDeletePermission()" class="actions-column">{{ 'form.list.actions' | translate }}</th>
          <th *ngFor="let column of displayedColumns">
            {{ getColumnDisplayName(column) }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of filteredData">
           <td *ngIf="hasEditPermission() || hasDeletePermission()" class="actions-column">
            <div class="action-buttons">
              <button class="action-btn view-btn"
                (click)="viewItem(item)"
                [title]="'form.list.view_details' | translate">
                <i class="fas fa-eye"></i>
                <!-- <span>{{ 'form.list.view' | translate }}</span> -->
              </button>
              <button *ngIf="hasEditPermission()"
                class="action-btn edit-btn"
                (click)="editItem(item)"
                [title]="'common.edit' | translate"
                [disabled]="isLoading">
                <i class="fas fa-edit"></i>
                <!-- <span>{{ 'common.edit' | translate }}</span> -->
              </button>
              <button *ngIf="hasDeletePermission()"
                class="action-btn delete-btn"
                (click)="deleteItem(item)"
                [title]="'common.delete' | translate"
                [disabled]="isLoading">
                <i class="fas fa-trash"></i>
                <!-- <span>{{ 'common.delete' | translate }}</span> -->
              </button>
            </div>
          </td>
          <td *ngFor="let column of displayedColumns">
            <ng-container *ngIf="item[column] && item[column].value !== undefined; else directDisplay">
              <ng-container [ngSwitch]="item[column].type">

                <ng-container *ngSwitchCase="'location'">
                  <div class="center-align location">
                  <a [href]="getGoogleMapsUrl(item[column].value)" target="_blank" title="Open Google Map">
                    <i class="fa-solid fa-location-dot"></i>
                  </a>
                </div>
                </ng-container>

                <ng-container *ngSwitchCase="'photo-upload'">
                  <div *ngFor="let photo of parsePhotos(item[column].value)" class="thumbnail">
                    <a [href]="photo.fileUrl" target="_blank" rel="noopener noreferrer">
                      <img [src]="photo.fileUrl" [alt]="photo.fileName" style="width:50px; height:50px; margin-right:4px; cursor:pointer;">
                    </a>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'avatar-upload'">
                  <div class="avatar-display" [ngClass]="'display-' + (item[column].value?.displayMode || 'square')" *ngIf="item[column].value">
                    <img [src]="item[column].value.previewUrl || item[column].value.fileUrl"
                         [alt]="'Avatar'"
                         class="avatar-thumbnail clickable"
                         (click)="viewImageFullSize(item[column].value.previewUrl || item[column].value.fileUrl)"
                         onerror="this.src='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNmNWY1ZjUiLz4KPGNpcmNsZSBjeD0iMjAiIGN5PSIxNiIgcj0iNiIgZmlsbD0iI2NjYyIvPgo8cGF0aCBkPSJNOCAzMmMwLTYuNjI3IDUuMzczLTEyIDEyLTEyaDhjNi42MjcgMCAxMiA1LjM3MyAxMiAxMnYwSDh2MHoiIGZpbGw9IiNjY2MiLz4KPC9zdmc+'"
                         [title]="item[column].value.fileName">
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'signature'">
                  <div class="signature-container" *ngIf="item[column].value && item[column].value !== ''">
                    <img [src]="item[column].value" alt="Signature" class="signature-thumbnail">
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'multi-checkbox'">
                  {{ getMultiCheckboxSelectedText(item[column].value) }}
                </ng-container>

                <ng-container *ngSwitchCase="'datetime'">
                  <ng-container *ngIf="item[column].value && item[column].value !== '' && convertUnixToLocal(item[column].value) !== null; else emptyDateTime">
                    {{ convertUnixToLocal(item[column].value) | date:'yyyy-MM-dd HH:mm:ss' }}
                  </ng-container>
                  <ng-template #emptyDateTime>
                    <!-- 空值時不顯示任何內容 -->
                  </ng-template>
                </ng-container>

                <!-- 子表單 -->
                <ng-container *ngSwitchCase="'subform-relation'">
                  <div class="subform-relation-display clickable"
                       (click)="loadSubform(item[column].value, item, column)"
                       [title]="'form.subform.click_to_view' | translate">
                    <!-- <i class="fas fa-link"></i> -->
                    <span class="subform-info">
                      <!-- <span class="subform-id">{{ item[column].value }}</span> -->
                      <span class="subform-count">{{ getSubformRecordCount(item[column].value, item.id) }} {{ 'common.records' | translate }}</span>
                    </span>
                    <!-- <i class="fas fa-external-link-alt view-icon"></i> -->
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'file-upload-manager'">
                  <div *ngIf="item[column].value?.files?.length > 0; else noFiles" class="file-manager-display">
                    <button class="btn btn-sm btn-outline-primary file-view-btn"
                            (click)="viewFile(item[column].value.files[0])"
                            [title]="item[column].value.files[0].name">
                      <i class="fas fa-file"></i> {{ 'form.list.view_file' | translate }}
                      <span *ngIf="item[column].value.files.length > 1" class="file-count">
                        (+{{ item[column].value.files.length - 1 }})
                      </span>
                    </button>
                  </div>
                  <ng-template #noFiles>
                    <!-- 空白顯示 -->
                  </ng-template>
                </ng-container>

                <ng-container *ngSwitchCase="'dynamic-api-table'">
                  <div class="dynamic-api-table-display clickable"
                       (click)="openDynamicApiTableDialog(item[column].value, getColumnDisplayName(column))"
                       [title]="'form.list.click_to_view_data' | translate">
                    <span class="data-count">
                      <i class="fas fa-table"></i>
                      {{ getDynamicApiTableCount(item[column].value) }} {{ 'common.records' | translate }}
                    </span>
                    <!-- <i class="fas fa-external-link-alt view-icon"></i> -->
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'approval-flow'">
                  <app-approval-flow-display
                    [steps]="convertToApprovalFlowSteps(item[column])"
                    [compact]="true"
                    [showLabels]="false"
                    [enableStepClick]="true"
                    [currentUserId]="currentUserId"
                    [formId]="item.id"
                    [formName]="formName"
                    [approvalFlow]="getApprovalFlowData(item[column])"
                    (approvalComplete)="onApprovalComplete($event)">
                  </app-approval-flow-display>
                </ng-container>

                <ng-container *ngSwitchCase="'meeting-signature-collection'">
                  <div class="meeting-signature-display clickable"
                       (click)="openMeetingSignatureDialog(item[column].value, getColumnDisplayName(column))"
                       [title]="'meeting.signature.click_to_view' | translate">
                    <i class="fas fa-users"></i>
                    <span class="signature-count">{{ getMeetingSignatureCount(item[column].value) }}</span>
                  </div>
                </ng-container>

                <ng-container *ngSwitchDefault>
                  {{ getDisplayValue(item[column].value) }}
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-template #directDisplay>
              {{ item[column] }}
            </ng-template>
          </td>

        </tr>
      </tbody>
    </table>
  </div>

  <!-- 子表單顯示區域 -->
  <div *ngIf="showSubform" id="subform-container" class="subform-container">
    <div class="subform-header">
      <div class="subform-title">
        <i class="fas fa-link"></i>
        <span>{{ 'form.subform.viewing' | translate }}</span>
        <span class="subform-title-text">{{ subformDisplayTitle }}</span>
      </div>
      <button class="close-subform-button" (click)="closeSubform()" [title]="'form.subform.close' | translate">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="subform-content">
      <app-showlist
        *ngIf="showSubform"
        [formId]="subformId"
        [formName]="subformName"
        [parentFormId]="currentParentFormId"
        (dataUpdated)="onSubformDataUpdated()">
      </app-showlist>
    </div>
  </div>

</div>

<!-- 編輯表單對話框 - 使用 Dynamic Form -->
<div *ngIf="showEditDialog" class="form-dialog-overlay">
  <div class="form-dialog">
    <div class="dialog-header">
      <h3>{{ 'form.list.edit_record' | translate }}</h3>
      <button class="close-button" (click)="closeEditDialog()" [disabled]="isLoading">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="dialog-content scrollable-content">
      <div *ngIf="editFormConfig.length === 0" class="no-editable-fields">
        <i class="fas fa-info-circle"></i>
        <p>{{ 'form.list.no_editable_fields' | translate }}</p>
      </div>

      <!-- 使用 Dynamic Form 元件進行編輯 -->
      <app-dynamic-form
        *ngIf="editFormConfig.length > 0"
        [formName]="formName + '_edit'"
        [config]="editFormConfig"
        [formid]="formId"
        [preview]="false"
        [initialValues]="editingItemData"
        (formSubmitted)="handleEditFormSubmit($event)"
        (formCancelled)="closeEditDialog()">
      </app-dynamic-form>
    </div>
  </div>
</div>

<!-- 刪除確認對話框 -->
<div *ngIf="showDeleteConfirm" class="confirm-dialog-overlay">
  <div class="confirm-dialog">
    <div class="dialog-header">
      <h3>{{ 'form.list.confirm_delete' | translate }}</h3>
      <button class="close-button" (click)="closeDeleteConfirm()" [disabled]="isLoading">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="dialog-content">
      <div class="confirm-message">
        <i class="fas fa-exclamation-triangle warning-icon"></i>
        <p>{{ 'form.list.delete_warning' | translate }}</p>
      </div>

      <div class="dialog-buttons">
        <button class="cancel-button" (click)="closeDeleteConfirm()" [disabled]="isLoading">
          {{ 'form.list.cancel' | translate }}
        </button>
        <button class="confirm-button" (click)="confirmDelete()" [disabled]="isLoading">
          <span *ngIf="isLoading">{{ 'form.list.deleting' | translate }}</span>
          <span *ngIf="!isLoading">{{ 'form.list.confirm_delete_button' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- 新增記錄對話框 -->
<div *ngIf="showAddRecordDialog" class="form-dialog-overlay">
  <div class="form-dialog">
    <div class="dialog-header">
      <h3>{{ formName }} - {{ 'form.list.add_record' | translate }}</h3>
      <button class="close-button" (click)="closeAddRecordDialog()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="dialog-content scrollable-content">
      <!-- 使用動態表單元件，傳遞必要參數 -->
      <app-dynamic-form
        [getuseridlist]="true"
        [formName]="formName"
        [formid]="formId"
        [parent_formid]="parentFormId"
        (recordAdded)="onRecordAdded()"
        [style.width]="'100%'"
      ></app-dynamic-form>
    </div>
  </div>
</div>

<!-- 編輯表單配置對話框 -->
<div *ngIf="showEditFormDialog" class="fullscreen-dialog">
  <div class="dialog-header">
    <h3>{{ 'form.list.edit_form_title' | translate }} - {{ editingFormConfig?.formName }}</h3>
    <div class="header-actions">
      <button class="close-button" (click)="closeEditFormDialog()">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>

  <div class="dialog-content scrollable-content">
    <div class="edit-form-placeholder">
      <div class="ai-chat-container">
        <div class="chat-messages">
          <div *ngFor="let message of editFormAiMessages" class="message" [class]="message.role">
            <div class="message-content" [innerHTML]="message.content | translate"></div>
          </div>
        </div>

        <div class="chat-input-container">
          <div class="input-wrapper">
            <textarea
              [(ngModel)]="editFormAiMessage"
              (keydown)="onEditFormKeyDown($event)"
              (input)="autoResizeEditFormInput($event)"
              placeholder="{{ 'form.list.ai_input_placeholder' | translate }}"
              class="chat-input"
              rows="1"
              [disabled]="isEditFormSending">
            </textarea>
            <button
              (click)="askEditFormAi()"
              class="send-button"
              [disabled]="isEditFormSending || (!editFormAiMessage.trim())">
              <i class="fas fa-paper-plane" *ngIf="!isEditFormSending"></i>
              <i class="fas fa-spinner fa-spin" *ngIf="isEditFormSending"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- 欄位設定對話框 -->
<div *ngIf="showColumnSettings" class="column-settings-overlay" (click)="closeColumnSettings()">
  <div class="column-settings-dialog" (click)="$event.stopPropagation()" (keydown.escape)="closeColumnSettings()">
    <div class="dialog-header">
      <h3 tabindex="0">{{ 'form.list.column_settings_title' | translate }}</h3>
      <button class="close-button" (click)="closeColumnSettings()" [attr.aria-label]="'form.list.cancel_settings' | translate">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="dialog-content">
      <!-- 欄位可見性設定 -->
      <div class="settings-section">
        <h4>{{ 'form.list.column_visibility' | translate }}</h4>
        <p class="section-description">{{ 'form.list.select_columns' | translate }}</p>

        <div class="column-checkboxes">
          <div *ngFor="let column of availableColumns" class="column-checkbox-item">
            <label class="checkbox-label">
              <input type="checkbox"
                     [checked]="isColumnVisible(column)"
                     (change)="toggleColumnVisibility(column)">
              <span class="checkmark"></span>
              <span class="column-name">{{ getColumnDisplayName(column) }}</span>
            </label>
          </div>
        </div>
      </div>

      <!-- 欄位順序設定 -->
      <div class="settings-section">
        <h4>{{ 'form.list.column_order' | translate }}</h4>
        <p class="section-description">{{ 'form.list.drag_to_reorder' | translate }}</p>

        <div class="column-reorder-list"
             cdkDropList
             (cdkDropListDropped)="dropColumn($event)">
          <div *ngFor="let column of getOrderedAvailableColumns()"
               class="column-reorder-item"
               cdkDrag
               [class.disabled]="!isColumnVisible(column)">
            <div class="drag-handle" cdkDragHandle>
              <i class="fas fa-grip-vertical"></i>
            </div>
            <span class="column-name">{{ getColumnDisplayName(column) }}</span>
            <span class="visibility-indicator"
                  [class.visible]="isColumnVisible(column)"
                  [class.hidden]="!isColumnVisible(column)">
              <i class="fas fa-eye" *ngIf="isColumnVisible(column)"></i>
              <i class="fas fa-eye-slash" *ngIf="!isColumnVisible(column)"></i>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="dialog-footer">
      <button class="btn btn-secondary" (click)="resetColumnSettings()">
        <i class="fas fa-undo"></i>
        {{ 'form.list.reset_columns' | translate }}
      </button>
      <div class="footer-actions">
        <button class="btn btn-outline-secondary" (click)="cancelColumnSettings()">
          {{ 'form.list.cancel_settings' | translate }}
        </button>
        <button class="btn btn-primary" (click)="applyColumnSettingsAndClose()">
          {{ 'form.list.apply_settings' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Dynamic API Table 資料顯示對話框 -->
<div *ngIf="showDynamicApiTableDialog" class="form-dialog-overlay">
  <div class="form-dialog large-dialog">
    <div class="dialog-header">
      <h3>{{ dynamicApiTableDialogTitle }}</h3>
      <button class="close-button" (click)="closeDynamicApiTableDialog()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="dialog-content scrollable-content">
      <div *ngIf="dynamicApiTableData.length === 0" class="no-data-message">
        <i class="fas fa-info-circle"></i>
        <p>{{ 'form.list.no_data_display' | translate }}</p>
      </div>

      <div *ngIf="dynamicApiTableData.length > 0" class="dynamic-api-table-container">
        <table class="table">
          <thead>
            <tr>
              <th *ngFor="let column of dynamicApiTableColumns">
                {{ getColumnDisplayName(column) }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of dynamicApiTableData">
              <td *ngFor="let column of dynamicApiTableColumns">
                {{ item[column] }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Meeting Signature Collection 詳細資訊對話框 -->
<div *ngIf="showMeetingSignatureDialog" class="form-dialog-overlay">
  <div class="form-dialog large-dialog">
    <div class="dialog-header">
      <h3>{{ meetingSignatureDialogTitle }}</h3>
      <button class="close-button" (click)="closeMeetingSignatureDialog()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="dialog-content scrollable-content">
      <div *ngIf="meetingSignatureData.participants.length === 0" class="no-data-message">
        <i class="fas fa-info-circle"></i>
        <p>{{ 'meeting.signature.no_participants' | translate }}</p>
      </div>

      <div *ngIf="meetingSignatureData.participants.length > 0" class="meeting-signature-container">
        <div class="signature-summary">
          <h4>{{ 'meeting.signature.statistics' | translate }}</h4>
          <p>{{ 'meeting.signature.signed_count' | translate }}: <strong>{{ meetingSignatureData.signedCount }}</strong></p>
          <p>{{ 'meeting.signature.total_count' | translate }}: <strong>{{ meetingSignatureData.totalCount }}</strong></p>
        </div>

        <div class="participants-list">
          <h4>{{ 'meeting.signature.participants_details' | translate }}</h4>
          <div class="table-container">
            <table class="table">
              <thead>
                <tr>
                  <th>{{ 'meeting.signature.name' | translate }}</th>
                  <th>{{ 'meeting.signature.title_field' | translate }}</th>
                  <th>{{ 'meeting.signature.department' | translate }}</th>
                  <th>{{ 'meeting.signature.status' | translate }}</th>
                  <th>{{ 'meeting.signature.signed_time' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let participant of meetingSignatureData.participants"
                    [class.signed]="participant.signature"
                    [class.unsigned]="!participant.signature">
                  <td>{{ participant.name }}</td>
                  <td>{{ participant.title || '-' }}</td>
                  <td>{{ participant.department || '-' }}</td>
                  <td>
                    <span *ngIf="participant.signature" class="status-badge signed">
                      <i class="fas fa-check-circle"></i> {{ 'meeting.signature.signed' | translate }}
                    </span>
                    <span *ngIf="!participant.signature" class="status-badge unsigned">
                      <i class="fas fa-clock"></i> {{ 'meeting.signature.unsigned' | translate }}
                    </span>
                  </td>
                  <td>
                    <span *ngIf="participant.signedAt">
                      {{ formatDate(participant.signedAt) }}
                    </span>
                    <span *ngIf="!participant.signedAt">-</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- 表單查看彈出視窗 -->
<div *ngIf="showViewForm" class="form-view-modal-overlay global-overlay" (click)="closeViewForm()">
  <div class="form-view-modal global-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>
        <i class="fas fa-eye"></i>
        {{ 'form.list.view_details' | translate }} - {{ viewFormName }}
      </h3>
      <button class="close-button" (click)="closeViewForm()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-content">
      <div *ngIf="viewFormConfig.length === 0" class="loading-message">
        <i class="fas fa-spinner fa-spin"></i>
        {{ 'common.loading' | translate }}
      </div>

      <div *ngIf="viewFormConfig.length > 0">
        <app-form-display
          [formName]="viewFormName"
          [config]="viewFormConfig"
          [formData]="viewFormData">
        </app-form-display>
      </div>
    </div>
  </div>
</div>
